import Disclaimer from "./Disclaimer";
import { Link } from "react-router-dom";
import { Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/60 mt-16 sm:mt-20">
      <div className="container py-10 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="font-display text-lg font-bold mb-2">
            Alea<span className="te-grad-text">Edge</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Premium AI sports analytics. The Top 5 daily plays, every day.
          </p>
          <div className="mt-4 flex items-center gap-2">
            <a
              href="https://twitter.com/aleaedge"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="AleaEdge on X"
              className="inline-grid place-items-center w-9 h-9 rounded-lg border border-border/60 text-muted-foreground hover:text-foreground hover:border-border transition"
            >
              <Twitter className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="text-sm space-y-1.5">
          <div className="font-semibold mb-2">Product</div>
          <Link to="/dashboard" className="block text-muted-foreground hover:text-foreground">Dashboard</Link>
          <Link to="/top-5" className="block text-muted-foreground hover:text-foreground">Top 5 Plays</Link>
          <Link to="/picks" className="block text-muted-foreground hover:text-foreground">All Picks</Link>
          <Link to="/history" className="block text-muted-foreground hover:text-foreground">Pick History</Link>
          <Link to="/pricing" className="block text-muted-foreground hover:text-foreground">Pricing</Link>
        </div>

        <div className="text-sm space-y-1.5">
          <div className="font-semibold mb-2">Company</div>
          <Link to="/" className="block text-muted-foreground hover:text-foreground">About</Link>
          <a href="mailto:support@aleaedge.com" className="block text-muted-foreground hover:text-foreground">Contact</a>
          <Link to="/pricing#faq" className="block text-muted-foreground hover:text-foreground">FAQ</Link>
        </div>

        <div className="text-sm space-y-1.5">
          <div className="font-semibold mb-2">Legal</div>
          <Link to="/terms" className="block text-muted-foreground hover:text-foreground">Terms of Service</Link>
          <Link to="/privacy" className="block text-muted-foreground hover:text-foreground">Privacy Policy</Link>
          <Link to="/billing-terms" className="block text-muted-foreground hover:text-foreground">Billing Terms</Link>
          <Link to="/refund-policy" className="block text-muted-foreground hover:text-foreground">Refund Policy</Link>
          <Link to="/responsible-gambling" className="block text-muted-foreground hover:text-foreground">Responsible Gambling</Link>
        </div>
      </div>

      <div className="container pb-6">
        <div className="text-xs text-muted-foreground border-t border-border/60 pt-4">
          <Disclaimer compact />
        </div>
        <div className="text-xs text-muted-foreground mt-3">
          © {new Date().getFullYear()} AleaEdge · Informational analytics only. 21+. Please bet responsibly.
        </div>
      </div>
    </footer>
  );
}
